export enum OrderCargoOrderActiveListItemExecutionStatus {
  CANDIDATURE = "CANDIDATURE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  PLANNED = "PLANNED",
}

export type OrderCargoOrderActiveListItemClient = {
  name: string;
};

export type OrderCargoOrderActiveListItemConsumer = {
  name: string;
};

export type OrderCargoOrderActiveListItemProducer = {
  id: string;
  name: string;
};

export type OrderCargoOrderActiveListItemAttentions = {
  newSharedPost: boolean;
  newPlanEntryPost: boolean;
  cargoOrderEdit: boolean;
  cargoOrderCancel: boolean;
};

export type OrderCargoOrderActiveListItem = {
  uuid: string;
  estimatedStartDate: Date;
  internalOrderId: number;
  routeAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: OrderCargoOrderActiveListItemClient | null;
  consumer: OrderCargoOrderActiveListItemConsumer | null;
  producer: OrderCargoOrderActiveListItemProducer | null;
  taxiCorporations: string[];
  drivers: string[];
  isMobileAppUser: boolean;
  executionStatus: OrderCargoOrderActiveListItemExecutionStatus;
  externalOrderId: string | null;
  attentions: OrderCargoOrderActiveListItemAttentions;
  slkStatus: boolean | null;
};

type OrderCargoOrderActiveList = {
  data: OrderCargoOrderActiveListItem[];
};

export default OrderCargoOrderActiveList;
